import * as React from "react";
import Typography from "Components/CommonComponents/Typography";
import {
  DropdownMenu,
  DropdownToggle,
  Navbar,
  Dropdown,
  Offcanvas,
  OffcanvasHeader,
} from "reactstrap";
import "./navbar.css";
import { UserInfoContext } from "Context/CommonContext";
import { capitalizeWords } from "utilFunctions/helperFunctions/HelperFunction";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import useGlobalSearchContext from "Context/GlobalSearchContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "utilFunctions/CustomHooks/useAuth";
import { capitalizeFirstCharaterOfString } from "utilFunctions/helperFunctions/utilFunctions";
import LogoutIcon from "Assets/Icons/LogoutIcon";
import MultiSearchBar from "utilFunctions/shared/MultiSearchBar";
import MenuIconWhite from "Assets/Icons/MenuIconWhite";
import FilterIconWhite from "Assets/Icons/FilterIconWhite";
import SearchWIcon from "Assets/Icons/SearchWIcon";
import LeftArrowWhite from "Assets/Icons/LeftArrowWhite";
import BellIcon from "Assets/Icons/BellIcon";
import { Badge } from "antd";
import {
  BASE_URL,
  USER_NOTIFICATIONS,
} from "utilFunctions/Constants/urlConstants";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";

import NotificationBar from "Components/CommonComponents/NotificationsBar/NotificationBar";
import styled from "styled-components";
import { FacultyPerformanceContext } from "Context/FacultyPerformanceContext";
import { LOPDashboardContext } from "Context/LOPDashboard";
import { MyBranchContext } from "Context/LOPDashboard";
import { SyllabusCompliancesContext } from "Context/SyllabusCompliances";
const StyledBadge = styled(Badge)`
  .ant-badge-dot.ant-scroll-number {
    left: 12px;
  }
`;
export const AppBar = (props: any) => {
  const { showNotification, setShowNotification } = props;
  const userInfo = React.useContext<any>(UserInfoContext);
  const { setFacultyPerformance } = React.useContext(FacultyPerformanceContext);
  const { setLOPDashboard } = React.useContext(LOPDashboardContext);
  const { setMyBranch } = React.useContext(MyBranchContext);
  const { setSyllabusCompliances } = React.useContext(
    SyllabusCompliancesContext
  );
  const { globalSearchData, saveGlobalSearchData } = useGlobalSearchContext();
  const { screen }: any = useWindowSize();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const [isSearchOpen, setIsSearchOpen] = React.useState(false);
  const [notifications, setNotifications] = React.useState<any>([]);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const notificationRef: any = React.useRef(null);
  const [limit] = React.useState<number>(10);
  const [offset, setOffSet] = React.useState<number>(0);
  const [hasMore, setHasMore] = React.useState<boolean>(false);
  const { makeRequest: GetNotifications, loading } = useGetApi(
    (searchData: any) => {
      if (
        searchData &&
        searchData != null &&
        searchData["data"] &&
        searchData["data"].length
      ) {
        setNotifications((previous: any) => [
          ...previous,
          ...searchData["data"],
        ]);
        setHasMore(
          searchData["data"] && searchData["data"].length > 0 ? true : false
        );
      }
    },
    (error: any) => {
      onFetchError(error);
    }
  );
  const onFetchError = (error: any) => {
    console.log("erorr onFetchError", error);
    setHasMore(false);
    if (offset == 0) {
      // setSuggestions([]);
    } else {
      setOffSet(0);
    }
  };

  console.log(userInfo);
  React.useEffect(() => {
    const url =
      BASE_URL +
      USER_NOTIFICATIONS +
      "?facultyId=" +
      userInfo.employeeId +
      "&limit=" +
      limit +
      "&offset=" +
      0;
    if (userInfo.employeeId) {
      if (notifications.length > 0) {
        setNotifications(notifications);
      } else {
        GetNotifications(url);
      }
    }
  }, [location, userInfo.employeeId]);
  const nextHandler = () => {
    const newOffset = offset + limit;
    setOffSet((previous) => previous + limit);
    const url =
      BASE_URL +
      USER_NOTIFICATIONS +
      "?facultyId=" +
      userInfo.employeeId +
      "&limit=" +
      limit +
      "&offset=" +
      newOffset;
    GetNotifications(url);
  };
  const handleSearchIcon = (path: any) => {
    if (path === "/admin/myBranch") {
      return saveGlobalSearchData({
        pathurl: path,
        isBranchHealth: true,
        isStudentHealth: false,
        isPerformance: false,
        isSyllabusCompliances: false,
        isBatches: false,
        isMyBatch: false,
      });
    } else if (path === "/admin/myBranch/") {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: true,
        isBranchHealth: false,
        isPerformance: false,
        isSyllabusCompliances: false,
        isBatches: false,
        isMyBatch: false,
      });
    } else if (
      path === "/admin/performance" ||
      isUrlPatterMatchOrNot(location.pathname, /\/performance\/(\d+)$/)
    ) {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: true,
        isSyllabusCompliances: false,
        isBatches: false,
        isMyBatch: false,
      });
    } else if (
      isUrlPatterMatchOrNot(location.pathname, /\/myBranch\/([^/]+)$/)
    ) {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: true,
        isBranchHealth: false,
        isPerformance: false,
        isBatches: false,
        isMyBatch: false,
      });
    } else if (path === "/admin/batches") {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: false,
        isMyBatch: false,
        isBatches: true,
      });
    } else if (
      isUrlPatterMatchOrNot(location.pathname, /\/batches\/([^/]+)$/)
    ) {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: false,
        isMyBatch: false,
        isBatches: true,
      });
    } else if (
      isUrlPatterMatchOrNot(location.pathname, /\/mybatch\/([^/]+)$/)
    ) {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: false,
        isBatches: false,
        isMyBatch: true,
      });
    } else if (path === "/admin/syllabusCompliances") {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: false,
        isSyllabusCompliances: true,
      });
    } else if (path === "/admin/faculties/regions") {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: false,
        isSyllabusCompliances: false,
        isFaculties: true,
      });
    } else if (path === "/admin/schedule") {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: false,
        isSyllabusCompliances: false,
        isFaculties: false,
        isSchedule: true,
      });
    } else if (path === "/admin/dashboard") {
      return saveGlobalSearchData({
        pathurl: path,
        isStudentHealth: false,
        isBranchHealth: false,
        isPerformance: true,
        isSyllabusCompliances: false,
        isBatches: false,
        isMyBatch: false,
      });
    } else {
      // Handle other cases or default behavior here
    }
  };
  const checkPathWithIdOrNot = (path: string) => {
    if (path.includes("myBranch")) {
      return isUrlPatterMatchOrNot(location.pathname, /\/myBranch\/([^/]+)$/);
    } else if (path.includes("mybatch")) {
      if (globalSearchData && globalSearchData.isFilterVisibale) {
        return isUrlPatterMatchOrNot(location.pathname, /\/mybatch\/([^/]+)$/);
      }
    } else if (path.includes("batches")) {
      return isUrlPatterMatchOrNot(location.pathname, /\/batches\/([^/]+)$/);
    } else return false;
  };
  const isUrlPatterMatchOrNot = (path: string, pattern: RegExp) => {
    return path.match(pattern);
  };

  const returnPageName = (path: string) => {
    if (
      !(
        "/admin/schedule".includes(path) ||
        isUrlPatterMatchOrNot(location.pathname, /\/attendance\/([^/]+)$/)
      )
    ) {
      localStorage.setItem("scheduledFilter", "");
      localStorage.setItem("eventType", "");
    }
    if (
      !(
        "/admin/batches".includes(path) ||
        isUrlPatterMatchOrNot(location.pathname, /\/mybatch\/([^/]+)$/)
      )
    ) {
      localStorage.setItem("myBatchsFilter", "");
    }
    if ("/admin/myBranch".includes(path)) {
      return "LOP Dashboard";
    } else if (
      "/admin/myBranch/".includes(path) ||
      isUrlPatterMatchOrNot(location.pathname, /\/myBranch\/([^/]+)$/)
    ) {
      return "LOP Dashboard";
    } else if (
      "/admin/performance".includes(path) ||
      isUrlPatterMatchOrNot(location.pathname, /\/performance\/(\d+)$/)
    ) {
      return "Student Performance";
    } else if ("/admin/planner".includes(path)) {
      return "Planners";
    } else if ("/admin/schedule".includes(path)) {
      return "Schedule";
    } else if ("/admin/batches".includes(path)) {
      return "Batches";
    } else if ("/admin/mylibrary".includes(path)) {
      return "My Library";
    } else if ("/admin/userManagement".includes(path)) {
      return "User Management";
    } else if ("/admin/syllabusCompliances".includes(path)) {
      return "Syllabus Compliance";
    } else if ("/admin/faculties/regions".includes(path)) {
      return "Faculty Performance";
    } else if (
      isUrlPatterMatchOrNot(location.pathname, /\/batches\/([^/]+)$/)
    ) {
      return "Batches";
    } else {
      return "👋 Hi, " + userInfo?.name?.split(" ")[0];
    }
  };
  const routeToMyProfile = (item: any) => {
    // navigate("/admin/myprofile/" + item.id, {
    //   replace: false,
    //   state: {
    //     userProfile: item,
    //   },
    // });
    navigate("/admin/faculties/" + item.id, {
      replace: false,
      state: {
        faculty: item,
        selectedDefaultTab: "2",
      },
    });
    toggle();
  };
  const onRequestClose = () => {
    setIsSearchOpen(!isSearchOpen);
  };
  const handleShowNotification = () => {
    setNotifications([]);
    setShowNotification && setShowNotification(!showNotification);
    setTimeout(() => {
      const url =
        BASE_URL +
        USER_NOTIFICATIONS +
        "?facultyId=" +
        userInfo.employeeId +
        "&limit=" +
        limit +
        "&offset=" +
        0;
      GetNotifications(url);
    }, 10);
  };
  React.useEffect(() => {
    const path = location.pathname;
    if (
      !(
        "/admin/faculties/regions".includes(path) ||
        isUrlPatterMatchOrNot(path, /\/branches\/([^/]+)$/) ||
        isUrlPatterMatchOrNot(path, /\/faculties\/([^/]+)$/) ||
        isUrlPatterMatchOrNot(path, /\/branch\/([^/]+)$/)
      )
    ) {
      setFacultyPerformance({});
    }
    if (
      !(
        "/admin/myBranch".includes(path) ||
        isUrlPatterMatchOrNot(path, /\/myBranch\/([^/]+)$/) ||
        isUrlPatterMatchOrNot(path, /\/performance\/([^/]+)$/)
      )
    ) {
      setLOPDashboard({});
      setMyBranch({});
    }
    if (
      !(
        "/admin/syllabusCompliances".includes(path) ||
        isUrlPatterMatchOrNot(path, /\/mybatch\/([^/]+)$/) ||
        isUrlPatterMatchOrNot(path, /\/performance\/([^/]+)$/)
      )
    ) {
      setSyllabusCompliances({});
    }
  }, [location]);

  React.useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotification(false);
        // setNotifications([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowNotification]);
  return (
    <Navbar className="navBarMain">
      {showNotification && (
        <div className="notfication-bar" ref={notificationRef}>
          <NotificationBar
            handleAfterRoute={() => {
              setShowNotification(false);
              setNotifications([]);
            }}
            hasMore={hasMore}
            nextHandler={nextHandler}
            notifications={notifications}
            loading={loading}
            setShowNotification={setShowNotification}
          />
        </div>
      )}
      <Offcanvas
        backdrop={true}
        className="w-100 filterSlider"
        isOpen={isSearchOpen}
        direction="end"
        toggle={onRequestClose}
      >
        <OffcanvasHeader className="filterHeader w-100"></OffcanvasHeader>
        <div className="globalSearchFilterDivMB">
          <LeftArrowWhite
            onClick={() => {
              setIsSearchOpen(!isSearchOpen);
            }}
          ></LeftArrowWhite>
          <MultiSearchBar onRequestClose={onRequestClose}></MultiSearchBar>
        </div>
      </Offcanvas>
      {["xxl", "xl", "lg"].includes(screen) ? (
        <>
          <div className="d-flex justify-content-between">
            <MenuIconWhite
              onClick={() => {
                props.toggleSidenav();
                props.setIsMiniSideBar(true);
              }}
            ></MenuIconWhite>
            <div className="navbarTitle pl-6 d-flex w-180 gap-4">
              <Typography
                variant={["xxl", "xl", "lg"].includes(screen) ? "h6F" : "h6"}
                color="white"
              >
                {capitalizeWords(returnPageName(location.pathname))}
              </Typography>
            </div>
          </div>
          <div className="d-flex">
            <MultiSearchBar />
            <div
              className={
                showNotification
                  ? "d-flex align-items-center cursor-pointer bellIconDiv"
                  : "d-flex align-items-center cursor-pointer bellIconDiv2"
              }
              onClick={handleShowNotification}
              style={{
                margin: "0px 15px",
                width: "36px",
                height: "36px",
              }}
            >
              <StyledBadge dot={notifications.length} size="small">
                <BellIcon></BellIcon>
              </StyledBadge>
            </div>
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle data-toggle="dropdown" tag="span">
                <span className="profileDivWithName">
                  {userInfo &&
                    userInfo.name &&
                    capitalizeFirstCharaterOfString(userInfo.name)}
                </span>
              </DropdownToggle>
              <DropdownMenu>
                <div
                  className="profileNameWithIconEmail mt-1"
                  onClick={() => routeToMyProfile(userInfo)}
                >
                  <span className="profileDivWithName ml-2">
                    {userInfo &&
                      userInfo.name &&
                      capitalizeFirstCharaterOfString(userInfo.name)}
                  </span>
                  <Typography variant="h6" color="info">
                    {userInfo.name}
                  </Typography>
                  <Typography variant="label" color="gray">
                    {userInfo.email}
                  </Typography>
                </div>
                <div
                  className="mt-1 pt-2 pb-1 logoutcss"
                  onClick={() => {
                    localStorage.removeItem("token");
                    localStorage.removeItem("refreshToken");
                    logout();
                  }}
                >
                  <div className="logoutTitle mr-2">Logout</div>
                  <div>
                    <LogoutIcon />
                  </div>
                </div>
              </DropdownMenu>
            </Dropdown>
          </div>
        </>
      ) : (
        <div className="w-100 d-flex flex-row align-items-center justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <MenuIconWhite
              onClick={() => {
                props.toggleSidenav();
                props.setIsMiniSideBar(true);
              }}
            ></MenuIconWhite>
            <div className="pl-3">
              <Typography
                variant={["xxl", "xl", "lg"].includes(screen) ? "h6F" : "h4"}
                color="white"
              >
                {userInfo &&
                  userInfo?.name &&
                  capitalizeWords(returnPageName(location.pathname))}
              </Typography>
            </div>
          </div>
          <div className="d-flex align-items-center">
            <div
              onClick={() => {
                setIsSearchOpen(true);
              }}
            >
              <SearchWIcon></SearchWIcon>
            </div>
            <div
              onClick={() => {
                navigate("/admin/notifications");
              }}
              className={
                showNotification
                  ? "d-flex align-items-center cursor-pointer bellIconDiv"
                  : "d-flex align-items-center cursor-pointer bellIconDiv2"
              }
              style={{
                margin: "0px 24px",
              }}
            >
              <StyledBadge dot={notifications.length} size="small">
                <BellIcon className="bellIcon"></BellIcon>
              </StyledBadge>
            </div>
            {[
              "/admin/branch",
              "/admin/myBranch",
              "/admin/syllabusCompliances",
              "/admin/faculties",
              "/admin/schedule",
            ].includes(location.pathname) ||
            checkPathWithIdOrNot(location.pathname.split("/admin/")[1]) ? (
              <div>
                <div
                  className="pl-2"
                  onClick={() => {
                    handleSearchIcon(location.pathname);
                  }}
                >
                  <div
                    className="d-flex align-items-center"
                    onClick={() => {
                      handleSearchIcon(location.pathname);
                    }}
                  >
                    {/* <span className="filterSpanWhite pr-2">Filter</span> */}
                    <FilterIconWhite className="cursor-pointer" />
                  </div>
                </div>
              </div>
            ) : null}
            {["/admin/dashboard"].includes(location.pathname) && (
              <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle data-toggle="dropdown" tag="span">
                  <span className="profileDivWithName ml-2">
                    {userInfo &&
                      userInfo.name &&
                      capitalizeFirstCharaterOfString(userInfo.name)}
                  </span>
                </DropdownToggle>
                <DropdownMenu>
                  <div
                    className="profileNameWithIconEmail mt-1"
                    onClick={() => routeToMyProfile(userInfo)}
                  >
                    <span className="profileDivWithName ml-2">
                      {userInfo &&
                        userInfo.name &&
                        capitalizeFirstCharaterOfString(userInfo.name)}
                    </span>
                    <Typography variant="h6" color="info">
                      {userInfo.name}
                    </Typography>
                    <Typography variant="label" color="gray">
                      {userInfo.email}
                    </Typography>
                  </div>
                  <div
                    className="mt-1 pt-2 pb-1 logoutcss"
                    onClick={() => {
                      localStorage.removeItem("token");
                      localStorage.removeItem("refreshToken");
                      logout();
                    }}
                  >
                    <div className="logoutTitle mr-2">Logout</div>
                    <div>
                      <LogoutIcon />
                    </div>
                  </div>
                </DropdownMenu>
              </Dropdown>
            )}
          </div>
        </div>
      )}
    </Navbar>
  );
};
